import { Link, Paper, Stack, Typography } from "@mui/material";

export function ContactInfo() {
    return (
        <Paper
            id="contact-us"
            sx={{
                backgroundColor: "white",
                borderRadius: 3,
                border: 2,
                borderColor: "#424ebc",
                p: 3,
                textAlign: "center",
                width: "100%",
            }}
        >
            <Stack spacing={2}>
                <Link
                    href="tel:+982172897000"
                    underline="hover"
                    sx={{
                        display: "block",
                        color: "text.secondary",
                        fontSize: "1.2rem",
                        "&:hover": {
                            color: "text.primary",
                        },
                    }}
                >
                    ۰۲۱-۷۲۸۹۷۰۰۰
                </Link>
            </Stack>

            <Typography variant="body1" sx={{ mt: 4, fontSize: "1.1rem" }}>
                ما از شنبه تا چهارشنبه از ۹ صبح تا ۶ عصر و پنج‌شنبه‌ها تا ۱ ظهر
                در خدمت شما هستیم
            </Typography>
        </Paper>
    );
}
